import { SVGProps } from 'react';

const LinkedinIcon = (props: SVGProps<SVGSVGElement>) => {
  const { className } = props;

  return (
    (<svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-palette="LinkedinIcon">
      <circle cx="18" cy="18" r="18" fill="#E1E2E5" />
      <path
        d="M12.5017 11C12.1034 11 11.7214 11.1582 11.4398 11.4398C11.1582 11.7214 11 12.1034 11 12.5017C11 12.8999 11.1582 13.2819 11.4398 13.5635C11.7214 13.8451 12.1034 14.0033 12.5017 14.0033C12.8999 14.0033 13.2819 13.8451 13.5635 13.5635C13.8451 13.2819 14.0033 12.8999 14.0033 12.5017C14.0033 12.1034 13.8451 11.7214 13.5635 11.4398C13.2819 11.1582 12.8999 11 12.5017 11ZM11.0883 15.24C11.0649 15.24 11.0424 15.2493 11.0259 15.2659C11.0093 15.2824 11 15.3049 11 15.3283V24.515C11 24.5638 11.0396 24.6033 11.0883 24.6033H13.915C13.9384 24.6033 13.9609 24.594 13.9775 24.5775C13.994 24.5609 14.0033 24.5384 14.0033 24.515V15.3283C14.0033 15.3049 13.994 15.2824 13.9775 15.2659C13.9609 15.2493 13.9384 15.24 13.915 15.24H11.0883ZM15.6817 15.24C15.6582 15.24 15.6358 15.2493 15.6192 15.2659C15.6026 15.2824 15.5933 15.3049 15.5933 15.3283V24.515C15.5933 24.5638 15.6329 24.6033 15.6817 24.6033H18.5083C18.5318 24.6033 18.5542 24.594 18.5708 24.5775C18.5874 24.5609 18.5967 24.5384 18.5967 24.515V19.5683C18.5967 19.2169 18.7363 18.8799 18.9847 18.6314C19.2332 18.3829 19.5703 18.2433 19.9217 18.2433C20.2731 18.2433 20.6101 18.3829 20.8586 18.6314C21.1071 18.8799 21.2467 19.2169 21.2467 19.5683V24.515C21.2467 24.5638 21.2862 24.6033 21.335 24.6033H24.1617C24.1851 24.6033 24.2076 24.594 24.2241 24.5775C24.2407 24.5609 24.25 24.5384 24.25 24.515V18.4235C24.25 16.7085 22.7589 15.3672 21.0523 15.522C20.5244 15.5704 20.0072 15.7011 19.5196 15.9092L18.5967 16.3049V15.3283C18.5967 15.3049 18.5874 15.2824 18.5708 15.2659C18.5542 15.2493 18.5318 15.24 18.5083 15.24H15.6817Z"
        fill="#676B72"
      />
    </svg>)
  );
};

export default LinkedinIcon;
